import React from 'react';
import './MonitoringCounter.css';

export default function MonitoringCounter() {
  return (
    <div id='monitor-counter' className='outsourcemainclass'>
        <div className="count">
          <h2>41%</h2>
          <span>
            Reduction in manual effort via GenAI-led workflow automation
          </span>
        </div>
        <div className="count">
          <h2>21%</h2>
          <span>
            Reduction in operational costs through intelligent process
            automation
          </span>
        </div>
        <div className="count">
          <h2>7h</h2>
          <span>
            Faster insights generation using natural language analytics &
            agentic AI
          </span>
        </div>
        <div className="count">
          <h2>60%</h2>
          <span>
            Faster insights generation using natural language analytics &
            agentic AI
          </span>
        </div>
      </div>
  )
}
